import useContryCurrencyHook, { defaultCurrencyCode } from "../../../common/hooks/useCountryCurrencyList.ts";
import { DotLegalCurrencyAmountField } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";
import { setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider.tsx";

export interface CustomAmountFieldProps {
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;

    // Value is a JsonObject, and it Uppercase
    value: { Amount: number | undefined; CurrencyCode: string };
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomAmountField(props: CustomAmountFieldProps) {
    const { language } = useUserContext();
    const { getCurrenciesAsIsoCodes } = useContryCurrencyHook();
    const currencies = props.isPreview ? [] : getCurrenciesAsIsoCodes();

    const { translateString } = useTranslation();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    const amount = (props.value as any)?.Amount ?? (props.value as any)?.amount;
    const currencyCode = (props.value as any)?.CurrencyCode ?? (props.value as any)?.currencyCode;

    return (
        <DotLegalCurrencyAmountField
            amountLabel={props.fieldName!}
            amount={amount?.toString()}
            onAmountChange={
                props.readOnly
                    ? () => {}
                    : (value) => {
                          onFieldChange({ amount: value ? parseFloat(value) : null, currencyCode: currencyCode ?? defaultCurrencyCode });
                      }
            }
            onCurrencyChange={
                props.readOnly
                    ? () => {}
                    : (value) => {
                          onFieldChange({ amount: amount ?? null, currencyCode: value });
                      }
            }
            currency={currencyCode ?? defaultCurrencyCode}
            currencyOptions={currencies}
            disabled={props.isDisabled}
            toolTipText={props.fieldDescription}
            useFixedLabel={props.useFixedLabel}
            debounce={!props.readOnly}
            noMargin={props.isPreview}
            amountErrorText={props.errorText}
            noOptionsLabel={translateString("noOptions")}
            seperatorStyle={language === "en" ? "en" : "da"}
            amountHelperText={
                props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.AmountField].toString())) : undefined
            }
        />
    );
}

export default CustomAmountField;
